import { render } from "./TSAVideo.vue?vue&type=template&id=35d90dbf&scoped=true"
import script from "./TSAVideo.vue?vue&type=script&lang=js"
export * from "./TSAVideo.vue?vue&type=script&lang=js"

import "./TSAVideo.vue?vue&type=style&index=0&id=35d90dbf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d90dbf"]])

export default __exports__